export let BusinessTags = /*#__PURE__*/function (BusinessTags) {
  BusinessTags["listDomains"] = "#listDomains";
  BusinessTags["domainAssignment"] = "#domainAssignment";
  BusinessTags["domainRegistration"] = "#domainRegistration";
  BusinessTags["domainConnect"] = "#domainConnect";
  return BusinessTags;
}({});
//# sourceMappingURL=businessTags.js.map